import { intl } from '@corti/i18n';
import { repositories } from 'core/repositories';
export function resolveUser(userID) {
    var _a;
    return ((_a = repositories.users.getUser(userID)) !== null && _a !== void 0 ? _a : {
        id: userID,
        name: `[${intl.t('realtime:unknownUser', 'Unknown user')}]`,
    });
}
